function isResponse(res) {
  if (res instanceof Response) return true;
  return res != null && typeof res.status === "number" && typeof res.ok === "boolean";
}
export {
  isResponse
};
//# sourceMappingURL=isResponse.js.map
